const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the category transfer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('categoryTransfer', ['Application', 'Categories', function (Application, Categories) {
  return {
    restrict: 'E',
    scope: {
      tabName: '=',
      refresh: '='
    },
    template: require('../../templates/directives/category-transfer.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.deleteAfter = true;
      self.showSelector = false;
      self.init = false;
      self.state = 'none';
      self.restrictions;
      self.transferFromCategory;
      self.transferToCategory;
      self.type;
      var capitalPlural = {
        category: 'Categories',
        location: 'Locations',
        department: 'Departments',
        team: 'Teams',
        org_level: 'Org_Levels',
        grade: 'Grades'
      };
      var plural = {
        category: 'categories',
        location: 'locations',
        department: 'departments',
        team: 'teams',
        org_level: 'org_levels',
        grade: 'grades',
      };
      self.onQuery = function(query) {
        Categories.get({subresource: query._id, fields: 'name,category,location,department,team,org_level,grade,level,children'}).$promise
        .then(function(cat) {
          if (self.state === 'none') {
            self.type = null;
            if(cat.category) {
              self.type = 'category';
            }
            if(cat.location) {
              self.type = 'location';
            }
            if(cat.department) {
              self.type = 'department';
            }
            if(cat.team) {
              self.type = 'team';
            }
            if(cat.org_level) {
              self.type = 'org_level';
            }
            if(cat.grade) {
              self.type = 'grade';
            }
            if (cat.children && cat.children.length) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: capitalPlural[self.type] + ' with children cannot be transferred from. Please first address all child ' + plural[self.type] + '.'});
              self.type = null;
              return;
            }
            self.transferFromCategory = cat;
            self.state = 'fromOnly';
            self.restrictions = {type: self.type, _id: cat._id};
            return;
          }
          if (self.state === 'fromOnly') {
            self.transferToCategory = cat;
            self.state = 'both';
            self.showSelector = false;
            return;
          }
        });
      };

      self.edit = function(type) {
        if (type === 'to') {
          self.transferToCategory = null;
          self.state = 'fromOnly';
          self.showSelector = true;
          return;
        }
        self.transferFromCategory = null;
        self.transferToCategory = null;
        self.state = 'none';
        self.restrictions = null;
        self.type = null;
        self.showSelector = true;
      };

      self.performTransfer = function() {
        var body = {
          remove_from: self.transferFromCategory._id,
          add_to: self.transferToCategory._id,
          retain: !self.deleteAfter
        };
        if (self.transferFromCategory.level === 10) {
          body.retain = true;
        }
        self.transferLoading = true;

        Categories.transfer({}, body).$promise
        .then(function(results) {
          Application.messaging.addMessage({type: 'success', duration: 5, text: 'Transfer complete!'});
          self.showConfirmation = false;
          $scope.refresh = self.type;
          self.edit();
          self.transferLoading = false;
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: 'There was an error in transferring the ' + self.type + '. Please contact your administrator.'});
          self.showConfirmation = false;
          self.transferLoading = false;
        });
      };

      if ($scope.tabName === 'transfer') {
        self.init = true;
        self.showSelector = true;
      }
      var tabWatch = $scope.$watch('tabName', function(newVal, oldVal) {
        if (newVal === 'transfer') {
          self.init = true;
          self.showSelector = true;
          tabWatch();
        }
      });

    }],
    controllerAs: 'transfer'
  };
}]);